var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedJup0)",
    d: "M5.905 16.01a7.4 7.4 0 0 0 2.313 2.02a7.65 7.65 0 0 0 2.969.933c-.539-.78-1.322-1.497-2.299-2.044a7.1 7.1 0 0 0-2.983-.909"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedJup1)",
    d: "M10.201 14.743c-1.883-1.053-3.921-1.321-5.38-.847q.212.674.555 1.295c1.267-.028 2.65.303 3.938 1.022c1.287.72 2.272 1.713 2.874 2.787q.731-.022 1.444-.178c-.294-1.454-1.548-3.025-3.43-4.079"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedJup2)",
    d: "M19.175 10.47a7.1 7.1 0 0 0-1.274-2.592a7.4 7.4 0 0 0-2.225-1.906a7.7 7.7 0 0 0-2.822-.916a7.8 7.8 0 0 0-2.97.218c1.612.19 3.4.772 5.155 1.753c1.754.98 3.167 2.188 4.136 3.442"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedJup3)",
    d: "M16.83 13.907c-.824-1.319-2.237-2.581-3.978-3.555c-1.74-.973-3.58-1.529-5.177-1.566c-1.405-.032-2.46.362-2.892 1.079l-.01.012a7 7 0 0 0-.102.405c.604-.23 1.305-.358 2.083-.372c1.732-.031 3.67.502 5.459 1.502s3.23 2.357 4.06 3.82c.372.66.604 1.308.695 1.928q.162-.138.314-.286l.008-.014c.432-.718.265-1.794-.46-2.953"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedJup4)",
    d: "M11.528 12.546c-2.666-1.49-5.612-1.724-7.028-.684q.005.49.077.973a6 6 0 0 1 1.28-.228c1.584-.115 3.329.31 4.912 1.196c1.584.886 2.832 2.135 3.513 3.514q.283.569.428 1.184q.473-.178.917-.417c.237-1.7-1.433-4.047-4.1-5.538"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedJup5)",
    d: "M18.202 11.7c-.835-1.317-2.26-2.583-4.013-3.563s-3.6-1.544-5.201-1.59c-1.222-.034-2.168.251-2.659.79c2.037-.332 4.724.226 7.328 1.682s4.44 3.426 5.148 5.294c.243-.677.032-1.609-.604-2.613"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedJup0",
    x1: 27.748,
    x2: -7.608,
    y1: -33.717,
    y2: 3.291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#C7F284"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00BEF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedJup1",
    x1: 20.242,
    x2: 0.782,
    y1: -10.305,
    y2: 11.733,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#C7F284"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00BEF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedJup2",
    x1: 11.431,
    x2: -7.589,
    y1: 12.28,
    y2: 33.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#C7F284"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00BEF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedJup3",
    x1: 15.461,
    x2: 3.225,
    y1: 3.427,
    y2: 18.354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#C7F284"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00BEF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedJup4",
    x1: 17.363,
    x2: 3.284,
    y1: -1.504,
    y2: 15.701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#C7F284"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00BEF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedJup5",
    x1: 14.273,
    x2: 7.908,
    y1: 7.844,
    y2: 19.211,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#C7F284"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00BEF0"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJup);
export default __webpack_public_path__ + "static/media/jup.00df5378cf5324f2dbd0eb821978e479.svg";
export { ForwardRef as ReactComponent };